module.exports = __webpack_public_path__ + "static/img/xianjin.6a106c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xianjin.png
// module id = m2SC
// module chunks = 1